import { render } from "./DocumentationsSecondForm.vue?vue&type=template&id=4ad9c92e"
import script from "./DocumentationsSecondForm.vue?vue&type=script&lang=js"
export * from "./DocumentationsSecondForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__